import React from "react";
import { NavLink } from "react-router-dom";
import "./MobileNavbar.css"; // Você criará este arquivo CSS

// Importações dos ícones mantidas conforme original



import bulletMenuMoreImg from "../../images/side_bar/more.svg";

import bulletHomeImg from "../../images/side_bar/MyMontepio.svg";
import bulletBeneficiosImg from "../../images/side_bar/beneficios.svg";
import bulletModalImg from "../../images/side_bar/modalidades.svg";

const MobileNavbar = () => {
    return (
        <nav className="mobile-navbar">
            <div className="nav-item-container">
                <NavLink exact activeClassName="active" className="nav-item" to="/">
                    <img src={bulletHomeImg} alt="Home" height="26px" width="26px" />
                    <span className="item_label" >Montepio</span>
                </NavLink>

            </div>

            <div className="nav-item-container">
                <NavLink exact activeClassName="active" className="nav-item" to="/beneficios">
                    <img src={bulletBeneficiosImg} alt="Benefícios" height="26px" width="26px" />
                    <span className="item_label" >Benefícios</span>
                </NavLink>
            </div>
            <div className="nav-item-container">
                <div className="nav-item" onClick={() => alert("Abrir Menu de Modalidades")}>
                    <img src={bulletModalImg} alt="Modalidades" height="26px" width="26px" />
                    <span className="item_label" >Modalidades</span>
                </div>
            </div>
            <div className="nav-item-container">
                <div className="nav-item" onClick={() => alert("Abrir Menu de Mais")}>
                    <img src={bulletMenuMoreImg} alt="Modalidades" height="26px" width="26px" />
                    <span className="item_label" >Mais</span>
                </div>
            </div>
        </nav >
    );
};

export default MobileNavbar;